import { render, staticRenderFns } from "./DashboardV1Component.vue?vue&type=template&id=10d6c316&"
import script from "./DashboardV1Component.vue?vue&type=script&lang=js&"
export * from "./DashboardV1Component.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV1Component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports